import React from 'react';

const Notice = (): JSX.Element => (
  <svg width="20px" height="20px" viewBox="0 0 20 20">
    <path d="M10,0 L10,0 Z M11,15 L9,15 L9,13 L11,13 L11,15 L11,15 Z M11,11 L9,11 L9,5 L11,5 L11,11 L11,11 Z" />
  </svg >
);

export default Notice;
